/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDomainMutationVariables = Types.Exact<{
  input: Types.SsoDomainDeleteInput;
}>;


export type DeleteDomainMutation = { __typename: 'Mutation', ssoDomainDelete: boolean };

export type SsoRevalidateMutationVariables = Types.Exact<{
  input: Types.SsoRevalidateInput;
}>;


export type SsoRevalidateMutation = { __typename: 'Mutation', ssoRevalidate: boolean };


export const DeleteDomainDocument = gql`
    mutation DeleteDomain($input: SsoDomainDeleteInput!) {
  ssoDomainDelete(input: $input)
}
    `;
export type DeleteDomainMutationFn = ApolloReactCommon.MutationFunction<DeleteDomainMutation, DeleteDomainMutationVariables>;

/**
 * __useDeleteDomainMutation__
 *
 * To run a mutation, you first call `useDeleteDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDomainMutation, { data, loading, error }] = useDeleteDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDomainMutation, DeleteDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDomainMutation, DeleteDomainMutationVariables>(DeleteDomainDocument, options);
      }
export type DeleteDomainMutationHookResult = ReturnType<typeof useDeleteDomainMutation>;
export type DeleteDomainMutationResult = ApolloReactCommon.MutationResult<DeleteDomainMutation>;
export type DeleteDomainMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDomainMutation, DeleteDomainMutationVariables>;
export const SsoRevalidateDocument = gql`
    mutation SsoRevalidate($input: SsoRevalidateInput!) {
  ssoRevalidate(input: $input)
}
    `;
export type SsoRevalidateMutationFn = ApolloReactCommon.MutationFunction<SsoRevalidateMutation, SsoRevalidateMutationVariables>;

/**
 * __useSsoRevalidateMutation__
 *
 * To run a mutation, you first call `useSsoRevalidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoRevalidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoRevalidateMutation, { data, loading, error }] = useSsoRevalidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoRevalidateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoRevalidateMutation, SsoRevalidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoRevalidateMutation, SsoRevalidateMutationVariables>(SsoRevalidateDocument, options);
      }
export type SsoRevalidateMutationHookResult = ReturnType<typeof useSsoRevalidateMutation>;
export type SsoRevalidateMutationResult = ApolloReactCommon.MutationResult<SsoRevalidateMutation>;
export type SsoRevalidateMutationOptions = ApolloReactCommon.BaseMutationOptions<SsoRevalidateMutation, SsoRevalidateMutationVariables>;